export default __webpack_public_path__ + "static/media/Profile.1c998f1f.png";